import * as CrowdDetail from '../services/crowdDetail';

export default {
  namespace: 'crowdDetail',

  state: {
    crowdDetail: null, //人群详情
    crowdPageDetailList: null, //详情列表
    computeStatus: null, //计算状态
    status: null, //状态
  },

  effects: {
    //详情接口
    *queryGroupInfo({ payload: { values } }, { call, put }) {
      const response = yield call(CrowdDetail.queryGroupInfo, values);
      yield put({
        type: 'save',
        payload: {
          crowdDetail: response?.data,
        },
      });
    },
    //人员详情列表
    *getQueryGroupHistoryPaget({ payload: { values } }, { call, put }) {
      const response = yield call(
        CrowdDetail.getQueryGroupHistoryPaget,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          crowdPageDetailList: response?.data,
        },
      });
    },
    // 计算状态
    *updateComputeStatus({ payload: { values }, callback }, { call, put }) {
      const response = yield call(CrowdDetail.updateComputeStatus, values);
      yield put({
        type: 'save',
        payload: {
          computeStatus: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 人群启用停用状态
    *updateGroupStatus({ payload: { values }, callback }, { call, put }) {
      const response = yield call(CrowdDetail.updateGroupStatus, values);
      yield put({
        type: 'save',
        payload: {
          status: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
